var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';
/**
 * @tdr
 * @tdr-deprecated-props: imageAlt, imageSrc, imageLazy
 * @tdr-deprecated-date: 2022-08-25
 */
export function Card(_a) {
    var _b, _c;
    var children = _a.children, fullHeight = _a.fullHeight, fullWidth = _a.fullWidth, imageSrc = _a.imageSrc, imageAlt = _a.imageAlt, imageLazy = _a.imageLazy, className = _a.className, image = _a.image, interactive = _a.interactive, footer = _a.footer, rest = __rest(_a, ["children", "fullHeight", "fullWidth", "imageSrc", "imageAlt", "imageLazy", "className", "image", "interactive", "footer"]);
    var showImage = !!image || (imageSrc && imageAlt);
    var columns = fullWidth || !showImage ? 1 : 2;
    var CardElement = interactive ? 'a' : 'div';
    return (React.createElement(CardElement
    // casting to Object is just a workaround. TODO: Figure out why it gives a type error without casting. Ticket: https://www.jlpit.com/jira/browse/WPIP-50892
    , __assign({}, rest, { className: cx(styles["card-columns-".concat(columns)], styles.card, className, (_b = {},
            _b[styles.hasFullWidthImage] = showImage && fullWidth,
            _b[styles.fullHeight] = fullHeight,
            _b[styles.interactive] = interactive,
            _b)) }),
        showImage && (React.createElement("div", { className: cx(styles.imageContainer, (_c = {},
                _c[styles.fullWidthImage] = fullWidth,
                _c)) }, image || (React.createElement("img", __assign({ alt: imageAlt, className: styles.image, src: imageSrc }, (imageLazy && { loading: 'lazy' })))))),
        React.createElement("div", { className: styles.contentWrapper },
            React.createElement("div", { className: styles.content }, children),
            !!footer && React.createElement("div", { className: styles.footer }, footer))));
}
//# sourceMappingURL=Card.js.map